import React from "react";
import { RCCChartGaugeChart } from "react-common-components";
import {IGaugeComponent} from "react-common-components/dist/components/Chart/GaugeChart/interface";
import { useTranslation } from "src/context/Translations/context";
import formatNumber from "src/utils/formatNumber";

const GaugeChart: React.FC<Omit<IGaugeComponent, "functionToFormat">> = ({
	...rest
}) => {
	const { currentLanguage } = useTranslation();
	return(
		<RCCChartGaugeChart
			functionToFormat={(val?: string | number) => !val && val !== 0 ? "" : formatNumber(val, currentLanguage)}
			{...rest}
		/>
	);};

export default GaugeChart;
